import React from 'react';
import { Award, Users, BookOpen } from 'lucide-react';
export function AuthorSection() {
  return <section className="py-12 px-4 bg-[#F0F4EC] border-y border-[#E8DFD0]" data-id="element-27">
      <div className="max-w-[800px] mx-auto" data-id="element-28">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-10" data-id="element-29">
          {/* Author Image */}
          <div className="w-full md:w-1/3 shrink-0 max-w-[280px]" data-id="element-30">
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden shadow-green-medium border-4 border-white" data-id="element-31">
              <div className="absolute inset-0 bg-[#2D5A3D]/10 mix-blend-multiply" data-id="element-32"></div>
              <img src="https://cdn.magicpatterns.com/uploads/osWgbviy3A7SXincXqZkBa/ChatGPT_Image_18_feb_2026,_09_20_15_p.m..png" alt="Shanon Greef" className="w-full h-full object-cover object-top" data-id="element-33" />
              <div className="absolute bottom-3 left-3 right-3 bg-white/95 backdrop-blur-sm p-2 rounded-lg text-center border border-[#2D5A3D]/20 shadow-sm" data-id="element-34">
                <p className="font-serif font-bold text-[#2D5A3D] text-base leading-none" data-id="element-35">
                  Shanon Greef
                </p>
                <p className="text-[10px] text-[#5C4A3A] uppercase tracking-wider mt-1 font-bold" data-id="element-36">
                  Maestra Herborista
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="w-full md:w-2/3 text-left" data-id="element-37">
            <div className="inline-flex items-center gap-2 bg-[#2D5A3D] text-white px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest mb-3 shadow-sm" data-id="element-38">
              <Award className="w-3 h-3" data-id="element-39" /> Autoridad Clínica
            </div>

            <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#2C1810] mb-6" data-id="element-40">
              ¿Quién es Shanon Greef?
            </h3>

            {/* Credential Pills */}
            <div className="flex flex-wrap gap-3 mb-6" data-id="element-41">
              <div className="bg-white border border-[#E8DFD0] rounded-full px-4 py-2 flex items-center gap-2 text-xs font-bold text-[#5C4A3A] shadow-sm" data-id="element-42">
                <Award className="w-4 h-4 text-[#2D5A3D]" data-id="element-43" />
                +20 años práctica clínica
              </div>
              <div className="bg-white border border-[#E8DFD0] rounded-full px-4 py-2 flex items-center gap-2 text-xs font-bold text-[#5C4A3A] shadow-sm" data-id="element-44">
                <Users className="w-4 h-4 text-[#2D5A3D]" data-id="element-45" />
                +2,000 pacientes tratados
              </div>
              <div className="bg-white border border-[#E8DFD0] rounded-full px-4 py-2 flex items-center gap-2 text-xs font-bold text-[#5C4A3A] shadow-sm" data-id="element-46">
                <BookOpen className="w-4 h-4 text-[#2D5A3D]" data-id="element-47" />
                Autora Best-Seller
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl border-l-4 border-[#2D5A3D] shadow-sm mb-6 relative" data-id="element-48">
              <Quote className="w-6 h-6 text-[#C17817]/40 absolute top-4 right-4" data-id="element-49" />
              <p className="text-lg font-serif italic text-[#2D5A3D] leading-relaxed pr-6" data-id="element-50">
                "No necesitas una farmacia. Necesitas entender cómo funcionan
                las plantas cuando trabajan juntas."
              </p>
            </div>

            <p className="text-[#2C1810] font-medium border-t border-[#E8DFD0] pt-4" data-id="element-51">
              Los protocolos de este manual son los mismos que usa con sus
              pacientes.{' '}
              <span className="text-[#2D5A3D] font-bold" data-id="element-52">
                Documentados. Probados. Listos para ti.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}
function Quote(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-53">
      <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" data-id="element-54" />
      <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" data-id="element-55" />
    </svg>;
}